import { colors } from "@material-ui/core";
import React from "react";

import { Button } from "@/design-system/components/Button/Button";
import { toast } from "@/design-system/components/Toast/Toast";

import { storeOAuthReturnDestinationId } from "@/oauth";
import { makeRequest } from "@/util";

import { ConfigureDestinationsModal } from "@/destinations/modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { BingIcon } from "@/components/icons/themes/logos";

const BingAdOAuthModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["developerToken", "accountID", "managerAccountID"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const BingAdOAuthRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const tokenSet = "developerToken" in settings;
  const accountIDSet = "accountID" in settings;
  const managerAccountIDSet = "managerAccountID" in settings;
  const allSet = tokenSet && accountIDSet && managerAccountIDSet;

  return (
    <DestinationConfigRow
      name="Developer Token, Account ID, and Manager Account ID"
      textColor={allSet ? "" : colors.red[600]}
      labelText={allSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthModal = () => {
  return null;
};

const OAuthRow = ({ existingConfig, destination }) => {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  const disableRow = !existingConfig.id;

  const onOpenConfigModal = () => {
    makeRequest("get_oauth_url", {
      integration_name: destination.slug,
      destination_id: existingConfig?.id,
    })
      .then((response) => {
        if (typeof response.data === "string" && response.data !== "") {
          storeOAuthReturnDestinationId(destination.slug, existingConfig.id);
          window.location.href = response.data;
        } else {
          throw new Error("Malformed response from get_oauth_url");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Something went wrong. Unable to setup " + destination.name + ".",
        );
      });
  };

  const loginButton = (
    <Button
      variant="outline"
      size="sm"
      className="border-[#0078D4]"
      leadingIcon={<BingIcon className="h-4 w-4" />}
      onClick={onOpenConfigModal}
    >
      {oauthConfigured ? "Reconnect" : "Connect with Microsoft"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access permission"
      disabled={disableRow}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={onOpenConfigModal}
    />
  );
};

const CREDENTIALS = "CREDENTIALS";
const OAUTH = "OAUTH";

const Rows = {
  [CREDENTIALS]: BingAdOAuthRow,
  [OAUTH]: OAuthRow,
};

const Modals = {
  [CREDENTIALS]: BingAdOAuthModal,
  [OAUTH]: OAuthModal,
};

const RowOrder = [CREDENTIALS, OAUTH];

const config = {
  Rows,
  RowOrder,
  Modals,
};
export default config;
